import FilterBorderedWrapper from "components/atoms/filter-bordered-wrapper/FilterBorderedWrapper";
import Icon from "components/atoms/icon/Icon";
import Input from "components/atoms/input/Input";
import DashboardBoxTitle from "components/atoms/title/DashboardBoxTitle";
import DynamicDropdown from "components/molecules/dynamic-dropdown/DynamicDropdown";
import DashboardBoxLayout from "components/templates/dashboard-box-layout/DashboardBoxLayout";
import { IconType } from "lib/helpers/constants/iconTypes";
import { FC, useState } from "react";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import ViewChangeButtonGroup from "components/molecules/view-change/ViewChangeButtonGroup";
import ConfigureTableDropdown from "components/organisms/leads/dropdowns/ConfigureTableDropdown";
import PendingsGridView from "../pendings-grid-view/PendingsGridView";
import PendingsList from "../pendings-list/PendingsList";
import CreatePending from "../create-pendings/CreatePending";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import PaginationControls from "components/molecules/pagination-controls/PaginationControls";
import NoDataBoundary from "components/atoms/no-data-boundary/NoDataBoundary";
import EmptyEntity from "components/atoms/empty-entity/EmptyEntity";
import CustomerFilterTable from "../filters/CustomerFilterTable";
import { useTranslation } from "react-i18next";
import UpdateLeadAppPending from "../update-lead-app-pending/UpdateLeadAppPending";
import { LeadAppPendingHeaders } from "lib/helpers/constants/columns/LeadAppPendingHeaders";
import { useOwnPendings } from "lib/hooks/queries/Pendings/useOwnPendings";
import OwnPendingCards from "../pendings-cards/OwnPendingCards";

interface IPendingsViewProps {

}

const OwnTable: FC<IPendingsViewProps> = () => {
    const [isCreatePendingModalOpen, setIsCreatePendingModalOpen] =
        useState<boolean>(false);

    const [currentPending, setCurrentPending] = useState<number>(1);


    const [configureTableOpen, setConfigureTableOpen] = useState<boolean>(false);
    const [filterTableOpen, setFilterTableOpen] = useState<boolean>(false);
    const [filterData, setFilterData] = useState<any>({
        filter_search: "",
        status: "",
        deadline: "",
        created_at: "",
    });
    const { t } = useTranslation();
    const [activeView, setActiveView] = useState<string>("listView");

    const {
        data,
        isLoading,
        handleItemsPerPageChange,
        handleNextPage,
        handlePreviousPage,
        hasNextPage,
        hasPreviousPage,
        itemsPerPage,
    } = useOwnPendings(
        filterData?.filter_search ?? "",
        filterData?.status ?? "",
        filterData?.deadline ?? "",
        filterData?.created_at ?? "",
    );



    const [ModalData, setModalData] = useState<{ modalType: string; data: any, isOwn: boolean }>()


    const [cardsOrder, setCardsOrder] = useState(LeadAppPendingHeaders({ setModalData, isOwn: true }));


    return (
        <div>
            <div>
                <OwnPendingCards/>
            </div>
            <DashboardBoxLayout className="mt-[26px]">
                <div className="flex flex-col gap-3 items-center justify-between mb-5 md:flex-row">
                    <div className="flex-1">
                        <DashboardBoxTitle
                            title={`${t('Own Pendings')}`}
                        />
                    </div>

                </div>
                <div className="flex flex-col gap-3 items-center mb-5 md:flex-row">
                    <div className="flex-1">
                        <Input
                            icon={IconType.SEARCH_ICON}
                            className=" border-0 !border-[#F2F4F7] indent-[35px] h-[48px] !rounded-[8px] text-[#7D8592] font-inter-regular shadow-customsecondary"
                            classes={{ icon: "left-4 !top-[30%]" }}
                            placeholder={t("Search by (Title)")}
                            value={filterData?.filter_search ?? ""}
                            onChange={(e) =>
                                setFilterData((prevFormData: any) => ({
                                    ...prevFormData,
                                    filter_search: e.target.value,
                                }))
                            }
                            maxLength={20}
                        />
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                        <div className="flex-none">
                            <div className={`relative`}>
                                <FilterBorderedWrapper
                                    className="cursor-pointer h-[48px] w-[48px] "
                                    onClick={() => {
                                        setConfigureTableOpen(!configureTableOpen);
                                    }}
                                >
                                    <Icon iconType={IconType.FILTER_BARS_ICON} />
                                </FilterBorderedWrapper>
                                <ConditionalRender condition={configureTableOpen}>
                                    <DynamicDropdown
                                        setIsOpen={setConfigureTableOpen}
                                        showCloseButton={true}
                                        title={t("Configure Table")}
                                    >
                                        <ConfigureTableDropdown
                                            setCardsOrder={setCardsOrder}
                                            cardsOrder={cardsOrder}
                                        />
                                    </DynamicDropdown>
                                </ConditionalRender>
                            </div>
                        </div>
                        <div className="flex-none">
                            <div className={`${filterTableOpen && "relative"}`}>
                                <FilterBorderedWrapper
                                    className="h-[48px] w-[48px] cursor-pointer"
                                    onClick={() => {
                                        setFilterTableOpen(!filterTableOpen);
                                    }}
                                >
                                    <Icon iconType={IconType.FILTER_ICON} />
                                </FilterBorderedWrapper>
                                <ConditionalRender condition={filterTableOpen}>
                                    <DynamicDropdown
                                        setIsOpen={setFilterTableOpen}
                                        showCloseButton={true}
                                        title={t("Filter")}
                                        className="sm:!w-[350px]"
                                    >
                                        <CustomerFilterTable
                                            setFilterData={setFilterData}
                                            FilterData={filterData}
                                            setIsOpen={setFilterTableOpen}
                                        />
                                    </DynamicDropdown>
                                </ConditionalRender>
                            </div>
                        </div>
                        <div className="flex-none">
                            <ViewChangeButtonGroup
                                setSelectedTab={setActiveView}
                                ActiveTab={activeView}
                            />
                        </div>
                    </div>
                </div>
                <ConditionalRender condition={activeView === "gridView"}>
                    <div className="relative">
                        {isLoading && <LoadingScreen />}
                        <NoDataBoundary
                            condition={data?.pages?.[0]?.data?.data?.length > 0}
                            fallback={<EmptyEntity name="Own Pendings" />}
                        >
                            <PendingsGridView data={data?.pages?.[0]?.data?.data ?? []} />
                        </NoDataBoundary>
                    </div>
                </ConditionalRender>
                <ConditionalRender condition={activeView !== "gridView"}>
                    <div className="relative">
                        {isLoading && <LoadingScreen />}
                        <NoDataBoundary
                            condition={data?.pages?.[0]?.data?.data?.length > 0}
                            fallback={<EmptyEntity name="Own Pendings" />}
                        >
                            <PendingsList
                                data={data?.pages?.[0]?.data?.data ?? []}
                                dataCols={cardsOrder}
                            />
                        </NoDataBoundary>
                    </div>
                </ConditionalRender>
            </DashboardBoxLayout>
            <PaginationControls
                itemsPerPage={itemsPerPage}
                handleItemsPerPageChange={(value: number) =>
                    handleItemsPerPageChange(value)
                }
                from={data?.pages[0]?.data?.from}
                to={data?.pages[0]?.data?.to}
                total={data?.pages[0]?.data?.total}
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
            />
            <ConditionalRender condition={currentPending === 1}>
                <CreatePending
                    currentPending={currentPending}
                    hocClasses={{
                        modalClassName: currentPending === 1 ? "md:w-[551px]" : "",
                    }}
                    hocCurrentStep={currentPending}
                    hocToggleModal={() =>
                        setIsCreatePendingModalOpen(!isCreatePendingModalOpen)
                    }
                    hocisOpen={isCreatePendingModalOpen}
                    setHocCurrentStep={setCurrentPending}
                    clearData={true}
                    hocTitle={t("Create New Pending")}
                />
            </ConditionalRender>

            <UpdateLeadAppPending
                userData={ModalData?.data}
                hocClasses={{
                    modalClassName: "sm:w-[600px] md:max-w-[600px] sm-md:max-w-[600px] lg:min-w-[973px] 2xl:w-[948px]"
                }}
                hocCurrentStep={1}
                hocToggleModal={() => setModalData(undefined)}
                closeModal={() => setModalData(undefined)}
                hocisOpen={ModalData?.modalType === "appLead"}
                clearData={true}
                isOwn={ModalData?.isOwn}
            />
        </div>
    );
};


export default OwnTable